import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { FintechIndustryPageBG } from "@/components/site/FintechIndustryPageBG";
import { FINTECH_META_DESCRIPTION_BG } from "@/content/meta/FintechIndustryPageBG";

export const Route = createFileRoute("/bg/industries/fintech")({
  head: () => ({
    meta: [
      { title: "Медиен мониторинг и анализи за финтех | Perceptica" },
      {
        name: "description",
        content: FINTECH_META_DESCRIPTION_BG,
      },

      { property: "og:title", content: "Медиен мониторинг и анализи за финтех | Perceptica" },
      { property: "og:description", content: FINTECH_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медиен мониторинг и анализи за финтех | Perceptica" },
      { name: "twitter:description", content: FINTECH_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/industries/fintech" },
      ...ogImageMeta("bg", "/industries/fintech"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/industries/fintech" }),
  }),
  component: FintechIndustryPageBG,
});
